<template>
  <router-link 
    :to="`/${lang}/${event.link}`"
    @mouseenter.native="setHover"
    @mouseleave.native="setHover"
    :style="{ opacity: hoverStatus }"
    class="event"
    js-anim="eventsList"
  >
    <Title 
      :text="event.titleFx"
      class="event__title"
    />
  </router-link>
</template>

<script>
import { TweenLite } from 'gsap/TweenLite';

import { mapGetters } from 'vuex';

import animations from '@/scripts/animations';
import { qs, qsa } from '@/scripts/utils';

import Title from '@/components/typo/Title';


export default {
  name: 'EventList',

  components: {
    Title,
  },

  props: ['event'],

  data() {
    return {
      hoverStatus: 1,
      hover: false,
      click: false,
    };
  },

  watch: {
    hoverEvent(newVal) {
      this.hoverStatus = !newVal || newVal === this.event.id ? 1 : 0.2;
      this.hover = newVal === this.event.id;
    },
  },

  computed: {
    ...mapGetters({
      hoverEvent: 'getHoverEvent',
      lang: 'getLang',
    }),
  },

  mounted() {
    this.$el.addEventListener('click', this.setClick);
  },

  methods: {
    setHover(event) {
      if (!this.click) {
        if (!this.hover) {
          this.targetEvent = event.target;
          this.targetEvent.style.zIndex = 20;
          this.$el.classList.add('hover');
          const animation = animations.get('hover')(this.$el);

          animation.play();
          this.$store.commit('SET_HOVEREVENT', this.event.id);
        } else {
          this.targetEvent.style.zIndex = 0;
          this.$store.commit('SET_HOVEREVENT', false);

          this.killLine(this.$el);
          this.$el.classList.remove('hover');
        }
        this.hover = this.hover ? !this.hover : true;
      } else {
        this.hover = false;
      }
    },

    setClick() {
      this.click = true;

      qs('.events', this.$parent.$el).classList.add('animating');
      this.killLine(this.$el);

      this.hover = false;
    },

    killLine() {
      const lines = qsa('[data-line]', this.$el);
      lines.forEach((line) => {
        TweenLite.killTweensOf(lines);

        TweenLite.set(line, {
          webkitClipPath: 'inset(0% 100% 0% 0%)',
          clipPath: 'inset(0% 100% 0% 0%)',
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../application';

.event {
  display: block;
  position: relative;

  margin: 0 0 $margin*2 0;
  line-height: 1em;
  transition: opacity 0.75s ease-out;

  &:last-child {
    margin: 0 0 $margin*1.5 0;
  }

  @include mq(sm) {
    display: inline;
    margin: 0;
  }

  &.animating {
    pointer-events: none !important;
  }

  &__title {
    display: inline;
    position: relative;

    line-height: 1.3em;


    @include mq(sm) {
      line-height: 1em;
    }
  }

  &:hover {
    color: $color-dark;
  }
}
</style>

<style lang="scss">
@import '../application';

.events {
  .event__title {
    [data-line] {
      display: none;

      position: absolute;
      left: 0;
      bottom: -10px;
      width: 100%;
      height: 18px;

      font-size: 0;
      overflow: hidden;
      border-radius: 30%;

      @at-root .cssclippathinset & {
        display: block;
      }

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 30px;
      }

      @include mq(sm) {
        bottom: 0;
      }

      svg {
        width: 1000px;
        height: 10px;

        vertical-align: top;
        transform: scale(1.6);

        @include mq(sm) {
          height: 18px;
        }
      }
    }
    .js-splittedlines {
      display: inline !important;
    }
    .js-splittedwords {
      display: inline-block !important;
      position: relative;

      overflow: hidden;
      line-height: 1.5em;
      vertical-align: text-bottom;

      @include mq(sm) {
        line-height: 1.75em;
      }
    }
    bdi {
      display: none;
      margin: 0 30px;

      transition: opacity 0.75s ease-out;

      @include mq(sm) {
        display: inline;
      }
    }
  }
  .hover {
    .event__title {
      z-index: 20;
      bdi {
        opacity: 0.2 !important;
      }
    }
  }

  .last {
    .js-splittedlines:last-child {
      display: none !important;
      visibility: hidden !important;
    }
  }

  &.animating {
    [data-line] {
      opacity: 0;
      transition: opacity 0.2s ease-out;
    }
  }
}
</style>

<style lang="scss">
@-moz-document url-prefix() {
  .events {
    .event__title {
      [data-line] {
        display: none !important;
      }
    }
  }
} 
</style>




// WEBPACK FOOTER //
// src/components/EventList.vue